import styled from 'styled-components';
// import { PRIMARY_COLOR } from './../constants/color';
export const SurveyWrapper: any = styled.div`

.pageBreadcrumb{
    // padding-top: 70px;
    top: 123px;
    position: fixed;
    /* width: 100%; */
    right: 0;
    left: 0;
    margin: 0px 40px;
    padding: 10px 0px 10px;
    padding-left: 30px;
    background-color: #ffffff;
    z-index: 1030;
    border-bottom: 2px solid #aaa;
}
.pageContent{
    padding-top: 150px;
}
.pageTitleSection .headingLink{
    display: inline-block;
    margin-left: 15px;
    margin-top: 15px;
    cursor: pointer;
}

.pageSurveyTopSection{
    padding: 15px 0px;
}

.pageSurveyContentSection table thead{
    border-top: 2px solid #aaa;
    border-bottom: 2px solid #aaa;
} 
.pageSurveyContentSection table thead tr th{
    color: #000;
} 
.pageSurveyContentSection table tbody tr th, .pageSurveyContentSection table tbody tr td{
    font-size: 18px !important;
}
.pageSurveyContentSection table tbody tr th *{
    font-size: 18px !important;
} 
.pageSurveyContentSection table tbody tr td *{ 
    font-size: 18px !important;
}
.pageSurveyContentSection table tbody tr th b .pageSurveyContentSection table tbody tr td b{
    font-size: 18px !important;
}
.pageSurveyContentSection table tbody tr td .tablePageIndex a{
    padding: 0px 5px;
    border-left: 1px solid #ccc;
    color: #000;
    font-size: 14px !important;
}
.pageSurveyContentSection table tbody tr td .tablePageIndex a:first-child{
    border-left: 0px;  
}

.pageSurveyContentSection table tbody tr td.tablePageIndex a:first-child{
    border-left: 0px;
}
.pageSurveyContentSection table tbody .moduleCategoryName{
    border-top: 2px solid #aaa;
}

.checkboxGroupControl .checkboxControl{
    margin: 0px;
}

// .pagePreviewWrapper{
//     margin: 0px 35px;
// }
// .MenuItem{
//     background-color: #000;
//     color: #fff;
// }
// .simple-menu .MuiList-padding-239{
//     background-color: #000;
// }
.MenuItem{
    float: right;
}
.EditSurvey{
    position: relative; 
    text-align: right;
}

.summaryTable{
    width: 100%;
}

.regionTitle{
    font-size: 18px;
    font-weight: bold;
}

.contentSection .checkboxGroupControl .checkboxControl [class*="MuiFormControlLabel-label-"]{
    font-size:18px;
}
.contentSection .checkboxGroupControl .checkboxControl .checkboxGroup label span + span {
    font-size:18px;
}
.deadlineFormcontrol{
    margin-top: 0px;
}
.deadlineFormcontrol #deadlineDate{
    padding: 11px 14px;
}

`


// WEBPACK FOOTER //
// ./src/styles/survey.tsx